import React from "react";
// this used to be part of React, now separate
// a prop type is like a variable type: string, number, boolean, etc.
import PropTypes from "prop-types"

// Header does not need to be a full blown component because the values are all static
// so we use "stateless functional component" see notes below

const Header = (props) => (
    <header className="top">
        <h1>
            Catch
            <span className="ofThe">
                <span className="of">of</span>
                <span className="the">the</span>
            </span>
            Day
        </h1>
        <h3 className = "tagline"><span>{props.tagline}</span></h3>
    </header>
);

// assign Prop Type to tagline
// we have to do this after the above because this is a "stateless functional component"
Header.propTypes = {
  tagline: PropTypes.string.isRequired
};

export default Header;

// NOTES
// since the below code does not really do anything other than spit out html
// it can be replaced by the above which is a "stateless functional component"
// so this is all re-written above

// class Header extends React.Component {
//     render() {
//         return (
//             <header className="top">
//                 <h1>
//                     Catch
//                     <span className="ofThe">
//                         <span className="of">of</span>
//                         <span className="the">the</span>
//                     </span>
//                     Day
//                 </h1>
//                 <h3 className = "tagline"><span>{this.props.tagline}</span></h3>
//             </header>
//         )
//     }
// }

// started with this:

// function Header {
//     return (
//         <p>html goes here {this.props.tagline}  </p>
//     )
// }

// but functions do not have "this" so:

// function Header(props) {
//     return (
//         <p>html goes here {props.tagline}  </p>
//     )
// }

//  you can rewrite this:

// function Header(props) {
//     return (
//         <p>html goes here {props.tagline}  </p>
//     )
// }

// to this:

// const Header = (props) => {
//     return (
//         <p>html goes here {props.tagline}  </p>
//     )
// };

// finally you shorten further with an "implicit return":

// const Header = (props) => (
//         <p>html goes here {props.tagline}  </p>
// );


//  could have done this without props:

// const Header = (tagline, age) => (
//     <header className="top">
//         <h1>
//             Catch
//             <span className="ofThe">
//                 <span className="of">of</span>
//                 <span className="the">the</span>
//             </span>
//             Day
//         </h1>
//         <h3 className = "tagline"><span>{tagline} {age}</span></h3>
//     </header>
// );

// the tagline was defined in App:
// <Header tagline="Fresh Seafood Market"/>
// You could add age:
// <Header tagline="Fresh Seafood Market" age={100}/>

// but he said that is a bit too much and stick with props








// WEBPACK FOOTER //
// ./src/components/Header.js